module.exports = __webpack_public_path__ + "media/images/menu-b5c47370498ca48435969120ba517ad5.png";